import { render, staticRenderFns } from "./ActionsMarketView.vue?vue&type=template&id=54ca1342&scoped=true"
import script from "./ActionsMarketView.vue?vue&type=script&lang=js"
export * from "./ActionsMarketView.vue?vue&type=script&lang=js"
import style0 from "./ActionsMarketView.vue?vue&type=style&index=0&id=54ca1342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca1342",
  null
  
)

export default component.exports